import {DATETIME_FORMATS} from 'util/DateConstants';

// audit logs
export const EXPORT_AUDIT_LOG_DISPLAY_STRING = 'View and export audit log';
export const EXPORT_AUDIT_LOG_MODAL_TITLE = 'Select format for audit log export';
export const EXPORT_RESULT_AUDIT_LOG_DISPLAY_STRING = 'View and export results audit logs';
export const EXPORT_TABLE_AUDIT_LOG_DISPLAY_STRING = 'View and export table audit logs';
export const EXPORT_RESULT_AUDIT_LOG_MODAL_TITLE = 'Select format for result audit log export';
export const EXPORT_AUDIT_LOG_UNSAVED_TABLE_TOOLTIP =
  'Audit logs are unavailable for newly inserted tables. Submit the table or refresh the page to view audit logs.';

// Export-only constants for custom handlers that don't support in-app viewing
// Certain custom export handlers (e.g., TAC reports, authentication options reports)
// only support file downloads and do not support displaying audit logs within the UI.
export const EXPORT_ONLY_AUDIT_LOG_DISPLAY_STRING = 'Export audit log';
export const EXPORT_ONLY_RESULT_AUDIT_LOG_DISPLAY_STRING = 'Export results audit logs';

// sample container history
export const EXPORT_SAMPLE_CONTAINER_HISTORY_DISPLAY_STRING = 'Export chain of custody - container history';
export const EXPORT_SAMPLE_CONTAINER_HISTORY_MODAL_TITLE = 'Select format for container history report';

// plate history
export const EXPORT_PLATE_HISTORY_DISPLAY_STRING = 'Export chain of custody - plate history';
export const EXPORT_PLATE_HISTORY_MODAL_TITLE = 'Select format for plate history report';
export const EXPORT_PLATE_HISTORY_ERROR_TOOLTIP = 'Please select exactly one plate.';

// location history
export const EXPORT_LOCATION_HISTORY_DISPLAY_STRING = 'Export location history';
export const EXPORT_LOCATION_HISTORY_MODAL_TITLE = 'Select format and date range for location history report';
export const EXPORT_LOCATION_HISTORY_ERROR_TOOLTIP = 'Report can only be exported for locations.';
export const LOCATION_HISTORY_TIME_RANGE_TOOLTIP =
  'The optional start and end dates limit the time period of the report. The report will include all entities and inventory objects that are present in the location during this time range.';

// column display names
export const AUDIT_LOG_OLD_VALUE_COLUMN = 'Old Value';
export const AUDIT_LOG_NEW_VALUE_COLUMN = 'New Value';

// empty cell placeholder
export const AUDIT_LOG_EMPTY_CELL_VALUE = 'N/A';

// datetime
export const EXPORT_AUDIT_LOG_MODAL_DATETIME_FORMAT = 'YYYY-MM-DD hh:mm A';
export const ALL_EXPORT_AUDIT_LOG_MODAL_DATETIME_FORMATS = [
  EXPORT_AUDIT_LOG_MODAL_DATETIME_FORMAT,
  ...DATETIME_FORMATS,
];
